import RequestManager from "../components/request/RequestManager";

const requestManager = new RequestManager();


export default requestManager